




import BuilderIo from '@/components/BuilderIo.vue';
import { defineComponent } from '@nuxtjs/composition-api';
import useRouterHistory from '@/hooks/useRouterHistory/useRouterHistory'


export default defineComponent({
  name: 'Home',
  layout: 'empty',
  components: {
    BuilderIo,
  },
  setup(){
    useRouterHistory()
  }
});
